const useUserIsWriting = () => {
  return () => {
    const activeElement = document.activeElement;

    return Boolean(
      activeElement &&
      (
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.getAttribute('contenteditable') === 'true'
      )
    );
  };
};

export default useUserIsWriting;
